import { render, staticRenderFns } from "./EditorialArticle.vue?vue&type=template&id=a3969c18&scoped=true"
import script from "./EditorialArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorialArticle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EditorialArticle.vue?vue&type=style&index=0&id=a3969c18&prod&lang=scss&scoped=true"
import style1 from "./EditorialArticle.vue?vue&type=style&index=1&id=a3969c18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3969c18",
  null
  
)

export default component.exports